/**
 * Форматирует дату/время в локальной таймзоне пользователя
 * Формат: DD.MM.YYYY HH:MM:SS
 * @param input - строка ISO, timestamp (мс или сек), или объект Date
 * @returns отформатированная строка или "—" при ошибке
 */
export function formatDateTime(input: string | number | Date | null | undefined): string {
  try {
    if (!input) return "—"

    // Преобразуем в Date
    let d: Date
    if (input instanceof Date) {
      d = input
    } else if (typeof input === 'number') {
      // Поддержка как миллисекунд, так и секунд
      const ms = input < 1_000_000_000_000 ? input * 1000 : input
      d = new Date(ms)
    } else {
      d = new Date(input)
    }

    if (Number.isNaN(d.getTime())) return "—"

    // Форматируем в локальной таймзоне
    return d.toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    })
  } catch {
    return "—"
  }
}

/**
 * Форматирует дату/время в локальной таймзоне (без секунд)
 * Формат: DD.MM.YYYY HH:MM
 * @param input - строка ISO, timestamp (мс или сек), или объект Date
 * @returns отформатированная строка или "—" при ошибке
 */
export function formatDateTimeShort(input: string | number | Date | null | undefined): string {
  try {
    if (!input) return "—"

    let d: Date
    if (input instanceof Date) {
      d = input
    } else if (typeof input === 'number') {
      const ms = input < 1_000_000_000_000 ? input * 1000 : input
      d = new Date(ms)
    } else {
      d = new Date(input)
    }

    if (Number.isNaN(d.getTime())) return "—"

    return d.toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    })
  } catch {
    return "—"
  }
}

/**
 * Форматирует только дату в локальной таймзоне
 * Формат: DD.MM.YYYY
 * @param input - строка ISO, timestamp (мс или сек), или объект Date
 * @returns отформатированная строка или "—" при ошибке
 */
export function formatDate(input: string | number | Date | null | undefined): string {
  try {
    if (!input) return "—"

    let d: Date
    if (input instanceof Date) {
      d = input
    } else if (typeof input === 'number') {
      const ms = input < 1_000_000_000_000 ? input * 1000 : input
      d = new Date(ms)
    } else {
      d = new Date(input)
    }

    if (Number.isNaN(d.getTime())) return "—"

    return d.toLocaleDateString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
  } catch {
    return "—"
  }
}

/**
 * Форматирует дату/время в UTC (используйте только для отладки/логов)
 * Формат: DD/MM/YYYY, HH:MM:SS
 * @deprecated Используйте formatDateTime для отображения пользователю
 */
export function formatDateTimeUtc(input: string | number | Date): string {
  const d = input instanceof Date ? input : new Date(input)
  if (Number.isNaN(d.getTime())) return "—"
  const yyyy = d.getUTCFullYear()
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0")
  const dd = String(d.getUTCDate()).padStart(2, "0")
  const HH = String(d.getUTCHours()).padStart(2, "0")
  const MM = String(d.getUTCMinutes()).padStart(2, "0")
  const SS = String(d.getUTCSeconds()).padStart(2, "0")
  return `${dd}/${mm}/${yyyy}, ${HH}:${MM}:${SS}`
}


















